import { useMemo } from 'react';
import CoursePreview from './CoursePreview';
import CommunityPreview from './CommunityPreview';
import PodcastPreview from './PodcastPreview';
import CoachingProgramPreview from './CoachingProgramPreview';
import LandingPagePreview from './LandingPagePreview';
import SalesEmailPreview from './SalesEmailPreview';
import CheckoutPreview from './CheckoutPreview';
import {
  CHECKOUT_ID,
  COACHING_PROGRAM_ID,
  COMMUNITY_ID,
  COURSE_ID,
  PODCAST_ID,
  SALES_EMAIL_ID,
} from '../../../utils/constants';

const HERO_BANNER_FALLBACK_URL =
  'https://kajabi-app-assets.kajabi-cdn.com/ai-lead-gen/course_preview_banner.png';

interface TransformedUnsplashObject {
  image_url: string;
  alt_description?: string;
}
interface PropTypes {
  selected: string;
  userData: { plan_to_sell: string };
  previewImageUrls: TransformedUnsplashObject[];
}

const BusinessPreviewSlideContent = ({
  selected,
  userData,
  previewImageUrls,
}: PropTypes) => {
  const heroImageUrl = useMemo(
    () => previewImageUrls.slice(-1)[0]?.image_url || HERO_BANNER_FALLBACK_URL,
    [previewImageUrls]
  );

  const Component = useMemo(() => {
    switch (selected) {
      case SALES_EMAIL_ID:
        return SalesEmailPreview;
      case CHECKOUT_ID:
        return CheckoutPreview;
      case COURSE_ID:
        return CoursePreview;
      case PODCAST_ID:
        return PodcastPreview;
      case COMMUNITY_ID:
        return CommunityPreview;
      case COACHING_PROGRAM_ID:
        return CoachingProgramPreview;
      default:
        return LandingPagePreview;
    }
  }, [selected]);

  return (
    <Component
      userData={userData}
      previewImageUrls={previewImageUrls}
      heroImageUrl={heroImageUrl}
    />
  );
};

export default BusinessPreviewSlideContent;
